var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlassesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7727 28.3929C5.18538 28.3929 1.46588 24.315 1.46588 19.2857C1.46588 16.6232 3.43509 14.4643 5.86361 14.4643H13.6818C16.1103 14.4643 18.0795 16.6232 18.0795 19.2857C18.0795 24.315 14.36 28.3929 9.7727 28.3929Z",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2273 28.3929C28.64 28.3929 24.9205 24.315 24.9205 19.2857C24.9205 16.6232 26.8897 14.4643 29.3182 14.4643H37.1364C39.5649 14.4643 41.5341 16.6232 41.5341 19.2857C41.5341 24.315 37.8146 28.3929 33.2273 28.3929Z",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46588 18.7502L7.03927 5.00267C8.12111 2.33374 11.3099 1.68445 13.1932 3.75017",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5341 18.7502L35.9607 5.00267C34.8789 2.33374 31.69 1.68445 29.8068 3.75017",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1705 14.4643H27.8523",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0795 20.8929H24.9204",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42044 19.2857C4.23004 19.2857 4.88635 18.5662 4.88635 17.6786C4.88635 16.791 4.23004 16.0714 3.42044 16.0714C2.61084 16.0714 1.95453 16.791 1.95453 17.6786C1.95453 18.5662 2.61084 19.2857 3.42044 19.2857Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37503 25.7143C6.18463 25.7143 6.84094 24.9947 6.84094 24.1071C6.84094 23.2196 6.18463 22.5 5.37503 22.5C4.56543 22.5 3.90912 23.2196 3.90912 24.1071C3.90912 24.9947 4.56543 25.7143 5.37503 25.7143Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30679 21.4286C9.11639 21.4286 9.7727 20.709 9.7727 19.8214C9.7727 18.9339 9.11639 18.2143 8.30679 18.2143C7.49719 18.2143 6.84088 18.9339 6.84088 19.8214C6.84088 20.709 7.49719 21.4286 8.30679 21.4286Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2386 17.1428C12.0482 17.1428 12.7045 16.4233 12.7045 15.5357C12.7045 14.6481 12.0482 13.9286 11.2386 13.9286C10.429 13.9286 9.77271 14.6481 9.77271 15.5357C9.77271 16.4233 10.429 17.1428 11.2386 17.1428Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2614 27.8571C11.071 27.8571 11.7273 27.1376 11.7273 26.25C11.7273 25.3624 11.071 24.6429 10.2614 24.6429C9.45178 24.6429 8.79547 25.3624 8.79547 26.25C8.79547 27.1376 9.45178 27.8571 10.2614 27.8571Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1932 23.5714C14.0028 23.5714 14.6591 22.8519 14.6591 21.9643C14.6591 21.0767 14.0028 20.3571 13.1932 20.3571C12.3836 20.3571 11.7273 21.0767 11.7273 21.9643C11.7273 22.8519 12.3836 23.5714 13.1932 23.5714Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 19.2857C16.9346 19.2857 17.5909 18.5662 17.5909 17.6786C17.5909 16.791 16.9346 16.0714 16.125 16.0714C15.3155 16.0714 14.6591 16.791 14.6591 17.6786C14.6591 18.5662 15.3155 19.2857 16.125 19.2857Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.875 19.2857C27.6846 19.2857 28.3409 18.5662 28.3409 17.6786C28.3409 16.791 27.6846 16.0714 26.875 16.0714C26.0655 16.0714 25.4091 16.791 25.4091 17.6786C25.4091 18.5662 26.0655 19.2857 26.875 19.2857Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8296 25.7143C29.6391 25.7143 30.2955 24.9947 30.2955 24.1071C30.2955 23.2196 29.6391 22.5 28.8296 22.5C28.02 22.5 27.3636 23.2196 27.3636 24.1071C27.3636 24.9947 28.02 25.7143 28.8296 25.7143Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7614 21.4286C32.571 21.4286 33.2273 20.709 33.2273 19.8214C33.2273 18.9339 32.571 18.2143 31.7614 18.2143C30.9518 18.2143 30.2955 18.9339 30.2955 19.8214C30.2955 20.709 30.9518 21.4286 31.7614 21.4286Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6932 17.1428C35.5028 17.1428 36.1591 16.4233 36.1591 15.5357C36.1591 14.6481 35.5028 13.9286 34.6932 13.9286C33.8836 13.9286 33.2273 14.6481 33.2273 15.5357C33.2273 16.4233 33.8836 17.1428 34.6932 17.1428Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7159 27.8571C34.5255 27.8571 35.1818 27.1376 35.1818 26.25C35.1818 25.3624 34.5255 24.6429 33.7159 24.6429C32.9063 24.6429 32.25 25.3624 32.25 26.25C32.25 27.1376 32.9063 27.8571 33.7159 27.8571Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6477 23.5714C37.4573 23.5714 38.1136 22.8519 38.1136 21.9643C38.1136 21.0767 37.4573 20.3571 36.6477 20.3571C35.8382 20.3571 35.1818 21.0767 35.1818 21.9643C35.1818 22.8519 35.8382 23.5714 36.6477 23.5714Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5796 19.2857C40.3891 19.2857 41.0455 18.5662 41.0455 17.6786C41.0455 16.791 40.3891 16.0714 39.5796 16.0714C38.77 16.0714 38.1136 16.791 38.1136 17.6786C38.1136 18.5662 38.77 19.2857 39.5796 19.2857Z",
    fill: "#131313"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassesIcon);
export default __webpack_public_path__ + "static/media/glasses-icon.a3faef1b02efb9ab5d000b8756606355.svg";
export { ForwardRef as ReactComponent };